
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/energy",
      function () {
        return require("private-next-pages/energy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/energy"])
      });
    }
  